import * as React from "react";
const ClickAndReserveContextDefaultValues = {
  activeStep: 0,
  setActiveStep: () => null,
  selectedStore: void 0,
  setSelectedStore: () => null,
  searchLocation: void 0,
  setSearchLocation: () => null,
  user: void 0,
  setUser: () => null,
  customerDetailsFormState: { current: void 0 },
  onChangeCustomerDetails: () => null,
  customerDetailsPrefilled: { current: false },
  isAuthLoading: true,
  reservationNumber: void 0,
  setReservationNumber: () => null,
  preferredChannelOfCommunication: void 0,
  setPreferredChannelOfCommunication: () => null
};
const ClickAndReserveContext = React.createContext(
  ClickAndReserveContextDefaultValues
);
const useClickAndReserveContext = () => React.useContext(ClickAndReserveContext);
export {
  ClickAndReserveContext,
  ClickAndReserveContextDefaultValues,
  useClickAndReserveContext
};
//# sourceMappingURL=ClickAndReserveContext.js.map
